import { render, staticRenderFns } from "./CustomJoditEditor.vue?vue&type=template&id=0d418767&scoped=true"
import script from "./CustomJoditEditor.vue?vue&type=script&lang=js"
export * from "./CustomJoditEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomJoditEditor.vue?vue&type=style&index=0&id=0d418767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d418767",
  null
  
)

export default component.exports